import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import PopupMessage from "../components/PopupMessage";
import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import EmailIcon from "@material-ui/icons/EmailOutlined";
import CancelIcon from "@material-ui/icons/CancelOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  redCell: {
    color: "red",
  },
  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT + 50}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },
  spacer: {
    flex: "1 1 100%",
  },

  formContent: {
    marginTop: `100px`,
    position: "absolute",
    marginLeft: "50px",
    marginRight: "50px",
    width: "1500px",
  },
});

class ContactUsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      subject: "",
      message: "",
      checkedA: false,
      phone: "",
      fax: "",
      email: "",
      buttonsDisabled: false,
      viewPopup: false,
      needReset: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  componentDidUpdate() {
    if (this.state.needReset) {
      this.setState({ needReset: false });
    }
  }
  componentDidMount() {
    //fetch('on_contact_us_init?r=' + new Date().getTime() + '&token=' + this.props.secureToken,
    fetch("on_contact_us_init", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ phone: reply.phone });
          this.setState({ fax: reply.fax });
          this.setState({ email: reply.email });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }
  handleSubmit(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (this.state.message.length === 0) {
      this.setState({ errorString: "Message is required" });
      this.setState({ viewPopup: true });
      return;
    }
    this.saveChanges();
  }

  handleCancel = (event) => {
    this.reset();
  };

  handleSubject = (event) => {
    this.setState({ subject: event.target.value });
  };

  handleMessage = (event) => {
    this.setState({ message: event.target.value });
  };

  handleChecked = (event) => {
    this.setState({ checkedA: event.target.checked });
  };

  reset() {
    this.setState({ checkedA: false });
    this.setState({ subject: "" });
    this.setState({ message: "" });
    this.setState({ needReset: true });
  }

  saveChanges() {
    fetch("on_contact_us_save", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        subject: this.state.subject,
        message: this.state.message,
        sendToBank: this.state.checkedA,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ notifyString: "Your message has been sent." });
          this.reset();
          this.setState({ viewPopup: true });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }
  render() {
    const { classes } = this.props;
    let { t } = this.props;
    return (
      <div>
        <Paper className={classes.toolbar}>
          <Toolbar>
            <Typography variant="h6" color="primary">
              {t("contactUs.label")}
            </Typography>
          </Toolbar>
          <div style={{ marginLeft: 20 }}>
            <Typography variant="caption" color="primary">
              {t("contactAdmin.label")}
              <br /> {t("phone.label")}:&nbsp;{this.state.phone}{" "}
              &nbsp;&nbsp;&nbsp;{t("email.label")}:&nbsp;{this.state.email}
            </Typography>
          </div>
        </Paper>
        <div className={classes.tableWrapper}>
          {this.state.viewPopup && this.state.errorString.length > 0 && (
            <PopupMessage
              title="Error"
              text={this.state.errorString}
              error={true}
              onClosePopup={this.onClosePopup}
            />
          )}
          {this.state.viewPopup && this.state.notifyString.length > 0 && (
            <PopupMessage
              title="Information"
              text={this.state.notifyString}
              error={false}
              onClosePopup={this.onClosePopup}
            />
          )}
          <div className={classes.formContent}>
            <Typography variant="h6" color="primary">
              {t("yourMessage.label")}
            </Typography>
            {!this.state.needReset && (
              <Paper elevation={1}>
                <form className="commentForm" onSubmit={this.handleSubmit}>
                  <TextField
                    margin="dense"
                    id="subject"
                    label={t("subject.label")}
                    type="text"
                    fullWidth
                    defaultValue={this.state.subject}
                    onChange={this.handleSubject}
                  />
                  <TextField
                    margin="dense"
                    id="message"
                    label={t("messageReq.label")}
                    multiline={true}
                    rows={2}
                    rowsMax={4}
                    type="text"
                    fullWidth
                    defaultValue={this.state.message}
                    onChange={this.handleMessage}
                  />
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          onChange={this.handleChecked}
                        />
                      }
                      label={t("sendEmail.label")}
                    />
                  </FormGroup>
                </form>
                <Button
                  onClick={this.handleSubmit}
                  color="primary"
                  disabled={this.state.buttonsDisabled}
                >
                  <EmailIcon />
                  &nbsp;
                  {t("submit.button")}
                </Button>
                <Button
                  onClick={this.handleCancel}
                  color="primary"
                  disabled={this.state.buttonsDisabled}
                >
                  <CancelIcon />
                  &nbsp;
                  {t("reset.button")}
                </Button>
              </Paper>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(ContactUsPage));
